import { Typography } from "antd";
import { useGetColumnSearchProps } from "./FilterTable/stringClearFiltros";

export function useIdColumn({
    show,
    dataIndex = 'id',
    ref,
    onClick,
    sorter = true
}: {
    show: boolean;
    dataIndex?: string;
    ref: any;
    onClick?: (id: any, record: any) => void;
    sorter?: boolean
}) {
    const searchProps = useGetColumnSearchProps({
        dataIndex,
        ref,
    });

    if (!show) return null;

    return {
        title: <span style={{ whiteSpace: 'nowrap' }}>ID</span>,
        dataIndex,
        key: dataIndex,
        width: 105,
        sorter,
        hidden: false,
        ...searchProps,
        render: (value: any, record: any) => (
            <Typography.Link
                onClick={(e) => {
                    e.stopPropagation();
                    onClick?.(value, record);
                }}
                style={{ whiteSpace: 'nowrap' }}
            >
                {value}
            </Typography.Link>
        ),
    };
}